/* loadingbag theme — header menu, PDP gallery, variant selection */
(function () {
  'use strict';

  /* ---- language picker: submit Shopify's localization form as soon as the
     visitor picks a different language from the dropdown ---- */
  document.querySelectorAll('[data-lang-picker-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.closest('form').submit();
    });
  });

  /* ---- hero video banner: cycle through slides, cross-fading. A video slide
     advances when its clip ends; a poster-only slide advances after a timed
     delay. Only the active slide's video plays, so audio/CPU stay idle on the
     rest. A segmented progress bar at the bottom fills in real time, synced to
     each slide's actual video duration (or a flat 6s for poster-only slides). ---- */
  document.querySelectorAll('[data-banner-cycle]').forEach(function (banner) {
    var slides = [].slice.call(banner.querySelectorAll('[data-banner-slide]'));
    if (slides.length < 2) {
      var only = slides[0] && slides[0].querySelector('video');
      if (only) only.play && only.play().catch(function () {});
      return;
    }
    var dots = [].slice.call(banner.querySelectorAll('[data-banner-dot]'));
    var fills = dots.map(function (d) { return d.querySelector('[data-banner-fill]'); });
    var current = slides.findIndex(function (s) { return s.hasAttribute('data-active'); });
    if (current < 0) current = 0;
    var posterTimer = null;

    function setFill(i, width, animate, duration) {
      var fill = fills[i];
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = width;
      if (animate) {
        void fill.offsetWidth; /* force reflow so the transition below actually runs */
        fill.style.transition = 'width ' + duration + 's linear';
        requestAnimationFrame(function () { fill.style.width = '100%'; });
      }
    }
    function startBar(i, seconds) { setFill(i, '0%', true, seconds); }

    function activate(index) {
      clearTimeout(posterTimer);
      slides.forEach(function (s) {
        var v = s.querySelector('video');
        if (v) { v.pause(); v.removeEventListener('ended', onEnded); }
      });
      slides[current].removeAttribute('data-active');
      fills.forEach(function (f, i) { if (f) setFill(i, i < index ? '100%' : (i === index ? '0%' : '0%'), false); });
      current = index;
      slides[current].setAttribute('data-active', '');
      var video = slides[current].querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.addEventListener('ended', onEnded);
        video.play && video.play().catch(function () {});
        if (video.readyState >= 1 && isFinite(video.duration)) {
          startBar(current, video.duration);
        } else {
          video.addEventListener('loadedmetadata', function once() {
            video.removeEventListener('loadedmetadata', once);
            startBar(current, isFinite(video.duration) ? video.duration : 8);
          });
        }
      } else {
        startBar(current, 6);
        posterTimer = setTimeout(next, 6000);
      }
    }
    function next() { activate((current + 1) % slides.length); }
    function onEnded() { next(); }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { activate(i); });
    });
    activate(current);
  });

  /* ---- header: nav buttons -> overlay dropdown/mega panel (same trigger works at every width) ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    var navBtns = [].slice.call(header.querySelectorAll('[data-nav-toggle]'));
    var navPanels = [].slice.call(header.querySelectorAll('[data-nav-panel]'));

    function closeNav() {
      navBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      navPanels.forEach(function (p) { p.hidden = true; });
      header.classList.remove('nav-open');
    }
    function openNav(key) {
      closeNav();
      var btn = header.querySelector('[data-nav-toggle="' + key + '"]');
      var panel = header.querySelector('[data-nav-panel="' + key + '"]');
      if (btn && panel) {
        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        header.classList.add('nav-open');
      }
    }

    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-nav-toggle');
        if (btn.getAttribute('aria-expanded') === 'true') { closeNav(); }
        else { openNav(key); }
      });
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeNav();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeNav(); }
    });

    /* mark the current page's link within each panel for styling/a11y only --
       must NOT auto-open the panel itself, or landing on any page whose link
       lives inside a dropdown (e.g. any collection, now that the mega menu's
       tiles link to real collections) would pop that whole overlay open
       unprompted on every load. */
    navPanels.forEach(function (panel) {
      var links = [].slice.call(panel.querySelectorAll('a'));
      var match = links.filter(function (a) { return a.pathname === location.pathname; })[0];
      if (match) {
        match.setAttribute('aria-current', 'page');
      }
    });
  }

  /* ---- PDP gallery: thumb -> main image ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    gallery.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-thumb');
        if (src) {
          main.src = src;
          main.alt = btn.getAttribute('data-alt') || main.alt;
        }
        gallery.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  });

  /* ---- PDP variants: option radios -> hidden <select name="id"> ---- */
  var optionsEl = document.querySelector('.pdp__options');
  var idSelect = document.querySelector('.pdp__id');
  var addBtn = document.querySelector('[data-add-to-cart]');
  var addLabel = document.querySelector('[data-add-label]');
  var priceEl = document.querySelector('.pdp__price .price');

  if (optionsEl && idSelect) {
    var variants = [];
    try { variants = JSON.parse(optionsEl.getAttribute('data-variants') || '[]'); } catch (e) {}

    var money = function (cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        }).format((cents || 0) / 100);
      } catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
    };

    var selectedOptions = function () {
      return Array.prototype.map.call(
        optionsEl.querySelectorAll('.pdp__option'),
        function (fs) {
          var checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    };

    var update = function () {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return !val || v.options[i] === val; });
      });
      if (!match) return;
      idSelect.value = match.id;
      if (priceEl) priceEl.innerHTML = '<span class="price__now">' + money(match.price) + '</span>';
      if (addBtn && addLabel) {
        addBtn.disabled = !match.available;
        addLabel.textContent = match.available ? '→ Add to cart' : 'Sold out';
      }
      // keep the URL variant param in sync (nice-to-have, no reload)
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    };

    optionsEl.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update();
    });
    update();
  }

  /* ---- product wall: capped to two rows, "see all products" reveals two more
     rows at a time (not everything at once) and stays on screen throughout ---- */
  document.querySelectorAll('[data-expand-products]').forEach(function (section) {
    var toggle = section.querySelector('[data-expand-products-toggle]');
    if (!toggle) return;
    var cols = parseInt(section.getAttribute('data-cols'), 10) || 6;
    var perClick = cols * 2;
    toggle.addEventListener('click', function () {
      /* only unhide the pagination wrappers (.drop__grid-extra) -- a plain
         [hidden] selector here would also match every already-visible tile's
         own (always-hidden-until-clicked) detail panel, popping those open
         instead of revealing more rows. */
      var hidden = [].slice.call(section.querySelectorAll('.drop__grid > .drop__grid-extra[hidden]'));
      hidden.slice(0, perClick).forEach(function (el) {
        el.removeAttribute('hidden');
      });
      if (!section.querySelectorAll('.drop__grid > .drop__grid-extra[hidden]').length) {
        toggle.hidden = true;
      }
    });
  });

  /* ---- B2B timeline: left list drives the sticky right-hand media stage ---- */
  document.querySelectorAll('[data-b2b]').forEach(function (section) {
    var items = [].slice.call(section.querySelectorAll('[data-b2b-item]'));
    var frames = [].slice.call(section.querySelectorAll('[data-b2b-frame]'));
    if (!items.length || !frames.length) return;

    function activate(key) {
      items.forEach(function (it) {
        it.classList.toggle('is-active', it.getAttribute('data-target') === key);
      });
      frames.forEach(function (fr) {
        var on = fr.id === key;
        if (on) { fr.setAttribute('data-active', ''); } else { fr.removeAttribute('data-active'); }
        var v = fr.querySelector('video');
        if (v) { if (on) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } }
      });
    }

    var intersecting = new Map();
    var suppressUntil = 0;

    function pickActive() {
      if (Date.now() < suppressUntil) return;
      var center = window.innerHeight / 2;
      var best = null, bestDist = Infinity;
      items.forEach(function (it) {
        if (!intersecting.get(it)) return;
        var r = it.getBoundingClientRect();
        var mid = r.top + r.height / 2;
        var dist = Math.abs(mid - center);
        if (dist < bestDist) { bestDist = dist; best = it; }
      });
      if (best) activate(best.getAttribute('data-target'));
    }

    items.forEach(function (it) {
      it.addEventListener('click', function () {
        activate(it.getAttribute('data-target'));
        suppressUntil = Date.now() + 700;
        it.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      it.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); it.click(); }
      });
    });

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { intersecting.set(e.target, e.isIntersecting); });
        pickActive();
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      items.forEach(function (it) { obs.observe(it); });
    } else {
      activate(items[0].getAttribute('data-target'));
    }
  });

  /* ---- one-off grid: click a tile to expand its detail panel in place ---- */
  document.querySelectorAll('[data-expand-grid]').forEach(function (grid) {
    var toggles = [].slice.call(grid.querySelectorAll('[data-expand-toggle]'));

    function close(toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', 'false');
      toggle.style.order = '';
      if (panel) { panel.hidden = true; panel.style.height = ''; panel.style.order = ''; }
    }
    /* the panel snaps to exactly 2 grid rows tall -- measured live off any
       other still-visible tile (tiles are aspect-ratio:1 squares, so their
       height already tracks the responsive column width). Not the clicked
       tile itself: it's hidden once expanded (its own small card must not
       keep showing in the grid), so it has no rendered height to read. */
    function sizePanel(panel) {
      if (window.matchMedia('(max-width: 700px)').matches) { panel.style.height = ''; return; }
      var ref = grid.querySelector('.pcard--square:not([hidden]):not([aria-expanded="true"])');
      if (ref) panel.style.height = (ref.getBoundingClientRect().height * 2) + 'px';
    }
    function open(toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      toggles.forEach(function (t) { if (t !== toggle) close(t); });
      toggle.setAttribute('aria-expanded', 'true');
      if (panel) {
        /* pull the clicked tile and its panel to the very front of the grid
           (CSS order), so no other product is ever listed above it -- every
           other tile sits at its default order and falls in behind. The
           tile itself is hidden by CSS ([aria-expanded="true"]{display:none})
           so only the panel shows where it used to be. */
        toggle.style.order = '-1';
        panel.style.order = '-1';
        sizePanel(panel);
        panel.hidden = false;
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (toggle.getAttribute('aria-expanded') === 'true') close(toggle); else open(toggle);
      });
    });

    window.addEventListener('resize', function () {
      var openToggle = toggles.filter(function (t) { return t.getAttribute('aria-expanded') === 'true'; })[0];
      if (!openToggle) return;
      var panel = document.getElementById(openToggle.getAttribute('aria-controls'));
      if (panel) sizePanel(panel);
    });

    grid.querySelectorAll('[data-expand-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-expand-panel]');
        var toggle = toggles.filter(function (t) { return t.getAttribute('aria-controls') === panel.id; })[0];
        if (toggle) close(toggle);
      });
    });

    /* per-panel media gallery: up to 3 images/videos, a segmented pager, and
       prev/next arrows over the image itself (all three drive the same state) */
    grid.querySelectorAll('[data-expand-panel]').forEach(function (panel) {
      var frames = [].slice.call(panel.querySelectorAll('[data-gallery-frame]'));
      var dots = [].slice.call(panel.querySelectorAll('[data-gallery-dot]'));
      var prev = panel.querySelector('[data-gallery-prev]');
      var next = panel.querySelector('[data-gallery-next]');
      if (!frames.length) return;

      function goTo(i) {
        var n = ((i % frames.length) + frames.length) % frames.length;
        frames.forEach(function (f, j) {
          if (j === n) { f.setAttribute('data-active', ''); } else { f.removeAttribute('data-active'); }
        });
        dots.forEach(function (d, j) {
          if (j === n) { d.setAttribute('data-active', ''); } else { d.removeAttribute('data-active'); }
        });
      }
      function current() {
        var i = frames.findIndex(function (f) { return f.hasAttribute('data-active'); });
        return i < 0 ? 0 : i;
      }
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    });
  });

  /* ---- B2B fixed enquiry dock: minimizable, never fully closable ---- */
  document.querySelectorAll('[data-b2b-sticky]').forEach(function (dock) {
    var toggle = dock.querySelector('[data-b2b-min-toggle]');
    var icon = dock.querySelector('[data-b2b-min-icon]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var min = dock.classList.toggle('is-min');
      toggle.setAttribute('aria-expanded', min ? 'false' : 'true');
      if (icon) icon.textContent = min ? '+' : '−';
    });
  });

  /* ---- animated "typed" placeholder — cycles search terms to draw the eye ---- */
  document.querySelectorAll('[data-typed-placeholder]').forEach(function (input) {
    var terms;
    try { terms = JSON.parse(input.getAttribute('data-terms') || '[]'); } catch (e) { terms = []; }
    if (!terms.length) return;
    var basePlaceholder = input.getAttribute('placeholder') || '';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var ti = 0, ci = 0, deleting = false, timer = null;
    function render() { input.setAttribute('placeholder', terms[ti].slice(0, ci) + '▏'); }
    function tick() {
      var word = terms[ti];
      if (!deleting) {
        ci++; render();
        if (ci >= word.length) { deleting = true; timer = setTimeout(tick, 1500); return; }
        timer = setTimeout(tick, 70 + Math.random() * 60);
      } else {
        ci--; render();
        if (ci <= 0) { deleting = false; ti = (ti + 1) % terms.length; timer = setTimeout(tick, 320); return; }
        timer = setTimeout(tick, 34);
      }
    }
    function start() { if (!timer && !input.value) { timer = setTimeout(tick, 500); } }
    function stop() { clearTimeout(timer); timer = null; }

    input.addEventListener('focus', function () { stop(); input.setAttribute('placeholder', basePlaceholder); });
    input.addEventListener('blur', function () { if (!input.value) { ci = 0; deleting = false; start(); } });
    start();
  });
})();
